<style>
.task_status {
	float: left;
	margin: 4px;
	height: 32px;
	padding: 3px 10px 3px 10px;
	border-color: black;
	border-style: solid;
	border-width: 1px;
	border-radius: 16px;	
}
</style>

<template>
	<div class="task_status" :style="status_style" @click.stop="do_click()">
		<tick_icon v-if="status.type==3" :color="enabled ? (is_pressed ? 'white' : status.color) : 'black'"/>
		<stop_icon v-if="status.type==4" :color="enabled ? (is_pressed ? 'white' : status.color) : 'black'"/>
		{{ status.desc }}
	</div>
</template>

<script>
import tick_icon from "@/components/icons/tick"
import stop_icon from "@/components/icons/stop"

export default {
	components: {
		tick_icon, stop_icon
	},
	props: {
		status: {
			type: Object,
			default: function() {
				return {
					id: 0,
					type: 0,
					desc: "",
					color: "black",
					isactive: true,
					order: 1
				}
			}
		},
		enabled: {
			type: Boolean,
			default: true
		},
		is_pressed: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		status_style() {
			let color = this.enabled ? this.status.color : '#DADADA';
			let style = "border-color: " + color + ";";

			if (this.is_pressed) {
				style += "background-color: " + color + ";";
				style += "color: white;";
				style += "box-shadow: 5px inset" + color + ";";
				style += "border-style: inset;"
			} else {
				style += "color: " + color + ";";
				style += "box-shadow: 2px 2px 1px " +  color + ";";
			}

			return style;
		},
	},
	methods: {
		do_click() {
			if (this.is_pressed) {
				// ignore, already the current value
			} else if (this.status.type == 4) {
				this.$emit('stuck');
			} else {
				this.$emit('click');
			}
		}
	}
}
</script>
